<template>
  <el-table
    v-loading="loading"
    :data="pageData.patientList"
    border
    stripe
    height="100%"
    :highlight-current-row="true"
    :header-cell-style="{ backgroundColor: '#F2F3F5', color: '#1D2129',borderColor: '#E5E6EB' }"
    @row-click="rowClick"
  >
    <el-table-column prop="name" label="名称" align="center" />
    <el-table-column prop="contactPhone" label="手机号" align="center" />
    <el-table-column prop="birthDate" label="生日" align="center" />
    <el-table-column prop="stateSign" label="状态" align="center">
      <template #default="scope">
        <el-tag>
          {{ scope.row.stateSign|STATUS_CODE_MAP }}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column prop="storeUserName" label="挂号医生" align="center" />
    <el-table-column prop="enrollTime" label="挂号时间" align="center" />
    <el-table-column prop="name" label="操作" align="center">
      <template #default="scope">
        <el-button
          type="text"
          @click="cancel(scope.row)"
        >退诊</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
import { postData } from "@/api/ik/data/dataApi"

export default {
  name: "PatientTable",
  inject: ["pageData"],
  filters: {
    STATUS_CODE_MAP(status) {
      switch (status) {
        case "1":
          return "待就诊"
        case "2":
          return "待配药"
        case "3":
          return "待结算"
        case "4":
          return "待取药"
        case "5":
          return "已完成"
        case "6":
          return "已关闭"
        default:
          return ""
      }
    }
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    /**
     * 退诊
     * @param row
     */
    cancel(row) {
      this.$confirm("确认要退诊吗？")
        .then(() => {
          const bgPath = "clinic/treatment/treatment/diagrecord/do/canceldiag"
          const pd = { code: row.code }
          this.loading = true
          postData(bgPath, pd)
            .then(res => {
              this.pageData.getPatientList()
              this.$message.success("退诊成功!")
            })
            .finally(() => {
              this.loading = false
            })
        })
    },
    /**
     * 行点击
     * @param row
     */
    rowClick(row) {
      this.getActivePreDiagRecord(row.code)
      // this.pageData.activeDiagRecord.diagRecord = { ...row }
    },
    /**
     * 获取进行中的预诊记录
     * @param code
     */
    getActivePreDiagRecord(code) {
      const url = "clinic/treatment/treatment/diagrecord/find/finddiagrecord"
      const pd = {
        code
      }
      postData(url, pd)
        .then(res => {
          this.pageData.resetActiveDiagRecord()
          this.pageData.activeDiagRecord = {
            ...this.pageData.activeDiagRecord,
            ...res.data
          }
        })
    }
  }
}
</script>
<style scoped lang="scss">
</style>
